import React from 'react';
import { usePushNotifications, useSendbirdConnection } from 'app/_modules/chat';

export const PushNotificationInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  usePushNotifications();
  useSendbirdConnection();
  
  return <>{children}</>;
};
